import './style.scss'
import { useContext, useEffect, useState } from "react";
import ApiContext from 'src/provider/API/call-service';
import { AbsoluteContainer, AppSpan, BillTypeContainer, CustomContainer, FlexRow, GridContainer, Input } from "src/style";
import { AppCenterPopupD2, BillsPaymentD2, CenterPopupHeaderD2 } from "src/component";
//import { BsGlobe, BsShieldCheck, BsThreeDots, BsTv } from 'react-icons/bs';
import { GiTakeMyMoney } from 'react-icons/gi';
import { FiSearch } from 'react-icons/fi';
import helpers from 'src/utils/helpers';

export const BillTypesD2: React.FC<any> =({close}) => {
    const {API} = useContext(ApiContext)
    const [billerCategories, setBillerCategories] = useState<any>(null)
    const [mockBillerCatrgories, setMockBillerCategories] = useState<any[]>([])
    const [selectedCategory, setSelectedCategory] = useState<any>(null)
    const [isLoading, setIsLoading] = useState(false)
    const [view, setView] = useState('bill-types')

    useEffect(() => {
        handleFetchBillerCategories()
    }, [])

    async function handleFetchBillerCategories () {
        setIsLoading(true)
        const response = await API.getBillerCategories()
        if (response) {
            setBillerCategories(response)
            setMockBillerCategories(response)
        }
        setIsLoading(false)
    }

    function handleSearch (e: React.ChangeEvent<HTMLInputElement>) {
        setMockBillerCategories(helpers.searchTableData(billerCategories, e.target.value, ['name']))
    }

    function handleSelect (data: any) {
        setSelectedCategory(data)
        setView('bills-payment')
    }
    
    return (
        <>
            { view === 'bill-types' &&
                <AppCenterPopupD2 height='87' zIndex='6' overflow='hidden' close={close}>
                    <CenterPopupHeaderD2 title='Bills Payment' close={close} />
                    { (isLoading) &&
                        <AbsoluteContainer top='0' left='0' zIndex='3' width='100' sizeUnit='%' height="full">
                            <GridContainer height='100' hUnit="%" bgColor='rgba(255, 255, 255, 0.5)'>
                                <AppSpan textSize='4' color='#0D968F' className='fa fa-spinner fa-spin' />
                            </GridContainer>
                        </AbsoluteContainer>
                    }
                    <CustomContainer 
                        height="87"
                        style={{maxHeight: '100%'}}
                        className="popup-content-container"
                    >
                        <CustomContainer
                            radius='0.8' borderColor='#D0D5DD' 
                            leftPadding='1.5' rightPadding='1.5' topMargin='2.5'
                            shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                        >
                            <FlexRow>
                                <FiSearch style={{fontSize: '2rem', color: '#667085'}} />
                                <Input 
                                    height='4.4' leftPadding='1' 
                                    placeholder='Search' 
                                    onChange={handleSearch}
                                />
                            </FlexRow>
                        </CustomContainer>
                        <FlexRow 
                            gap='1.5' wrap='wrap' topMargin='2'
                            maxHeight='78' mxHUnit='%' alignItems='flex-start'
                            className='overflow-y-container'
                        >
                            {
                                mockBillerCatrgories?.map((item: any, index: number) => {
                                    return (
                                        <BillTypeContainer 
                                            sizeUnit='' minHeight='4.5' radius='0.5' padding='1'
                                            borderColor={selectedCategory === item.name ? '#0D968F' : '#EAECF0'}
                                            bgColor={selectedCategory?.name === item.name ? '#0D968F' : '#ffffff'}
                                            key={index}
                                            onClick={() => handleSelect(item)}
                                        >
                                            <FlexRow>
                                                <AppSpan
                                                    textSize='1.6' topMargin='-0.2' cursor='pointer'
                                                    color={selectedCategory?.name === item.name ? '#ffffff' : '#0D968F'}
                                                >
                                                    {/* {item.icon} */}
                                                    <GiTakeMyMoney />
                                                </AppSpan>
                                                <AppSpan
                                                    leftMargin='1' cursor='pointer'
                                                    color={selectedCategory?.name === item.name ? '#ffffff' : '#0D968F'}
                                                >
                                                    {item.name}
                                                </AppSpan>
                                            </FlexRow>
                                        </BillTypeContainer>
                                    )
                                })
                            }
                        </FlexRow>
                    </CustomContainer>
                </AppCenterPopupD2>
            }
            { view === 'bills-payment' &&
                <BillsPaymentD2 
                    close={close}
                    back={() => setView('bill-types')}
                    selectedBillerCategory={selectedCategory}
                    billerCategories={billerCategories}
                />
            }
        </>
    )
}

